
const statList = 'avg,atBats,homeRuns,rbi,ops';
const matchupDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        
        const {
            gumbo : {
                gameData: {
                    game: {
                        pk
                    } = {}
                } = {}
            } = {}
        } = state || {}
        
        componentDataEngine.fetchAndStore('teamvsPitcher', {
            gamePk: pk,
            statList
        });
    };
  };
  
  export default matchupDataRequestAction;
  